export class RMetaPixel {
  static _fbq;

  static startTracking(fbPixelId, eventAggregator) {
    RMetaPixel._attachScript()
    // Configure
    RMetaPixel._fbq('init', fbPixelId);

    // Subscribe to router: send page views to facebook
    eventAggregator.subscribe('router:navigation:success', event => {
      RMetaPixel.trackPageView()
    });
  }

  static trackPageView() {
    RMetaPixel._track('PageView');
  }

  static trackSubscribe(price) {
    RMetaPixel._track('Subscribe', {
      value: price,
      currency: 'NOK'
    });
  }

  // content_types
  // "product" → most common (single item)
  // "product_group" → variants grouped (size/color)
  // "service" → SaaS, subscriptions, bookings
  static trackViewContent_product(productArticleNumber) {
    RMetaPixel._track('ViewContent', {
      content_ids: [productArticleNumber],
      content_type: 'product',
      // value: 49.99,
      // currency: 'NOK'
    });
  }

  static trackAddToCart(productArticleNumber, price) {
    RMetaPixel._track('AddToCart', {
      content_ids: [productArticleNumber],
      content_type: 'product',
      value: price,
      currency: 'NOK'
    });
  }

  static trackInitiateCheckout(articleNumbers, totalPrice, totalNumberOfItems) {
      RMetaPixel._track('InitiateCheckout', {
        content_ids: articleNumbers,
        content_type: 'product',
        num_items: totalNumberOfItems,
        value: totalPrice,
        currency: 'NOK'
      });
  }

  static trackCompleteRegistration() {
    RMetaPixel._track('CompleteRegistration');
  }

  static _track(...a) {
    if (!RMetaPixel._fbq) {
      console.warn("Trying to track event before fbq function is loaded.")
      return;
    }
    console.info("RMetaPixel tracking: ", a);
    RMetaPixel._fbq('track', ...a);
  }

  static _attachScript() {
    // Load facebook pixel global fbq function
    !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
    n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(
      window,
      document,
      'script','https://connect.facebook.net/en_US/fbevents.js'
    );
    RMetaPixel._fbq = fbq;
  }
}
